export const PREFIX = {
  API_V1: "api/v1",
  AVATAR_DIR: "sso-service/static/images/avatars",
  DEV: "dev",
  PROD: "production",
  QA: "qa",
  LOCAL: "local",
};
